import { z } from "zod"

export const payrollClassificationV1Schema = z.enum(["employee", "contractor"])

export const payrollReadinessBlockerV1Schema = z.enum([
  "relationship_missing",
  "relationship_inactive",
  "relationship_outside_effective_window",
  "relationship_classification_overlap",
  "legal_entity_mismatch",
  "onboarding_incomplete",
  "worklio_mapping_unverified",
  "approval_missing",
  "jurisdiction_unsupported",
  "jurisdiction_pack_stale",
  "payroll_period_closed",
])

export const payrollReadinessFactsV1Schema = z
  .object({
    workerId: z.string().uuid(),
    legalEntityId: z.string().uuid(),
    asOfDate: z.string().date(),
    periodId: z.string().uuid(),
    relationshipKinds: z.array(payrollClassificationV1Schema).max(2),
    relationshipActive: z.boolean(),
    withinEffectiveWindow: z.boolean(),
    relationshipLegalEntityId: z.string().uuid().nullable(),
    onboardingComplete: z.boolean(),
    worklioMappingVerified: z.boolean(),
    approvalComplete: z.boolean(),
    jurisdictionSupported: z.boolean(),
    jurisdictionPackCurrent: z.boolean(),
    periodOpen: z.boolean(),
  })
  .strict()

export const payrollReadinessDecisionV1Schema = z
  .object({
    ready: z.boolean(),
    classification: payrollClassificationV1Schema.nullable(),
    blockerCodes: z.array(payrollReadinessBlockerV1Schema),
    timePreserved: z.literal(true),
    exportAvailable: z.literal(true),
  })
  .strict()

export type PayrollReadinessFactsV1 = z.infer<
  typeof payrollReadinessFactsV1Schema
>
export type PayrollReadinessDecisionV1 = z.infer<
  typeof payrollReadinessDecisionV1Schema
>
